import {Button, Modal} from "react-bootstrap";
import SuccIcon from "../../../images/ModalSucc.svg";
import mobileImg from "../../../images/bl 1.png";
import android from "../../../images/Android 1.png";
import ios from "../../../images/Ios 1.png";
import {useState} from "react";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";

const RedirectMobileModal = ({
  show,
  setShow,
  handelButton,
  title,
  message,
  buttonTitle,
  secondButtonTitle,
  handelSecondButton,
}) => {
  const APKUrl =
    "https://play.google.com/store/apps/details?id=com.helpclic&hl=fr";
  const IOSUrl = "#";
  return (
    <Modal
      className="modal fade"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      centered
    >
      <div className="modal-content">
        {/* <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              setShow(false);
            }}
          >
            <span>×</span>
          </Button>
        </div> */}
        <div className="modal-body !p-6">
          <div className=" flex flex-col gap-2 justify-center items-center sm:!px-12 ">
            <img src={mobileImg} alt="ToastIcon" className="w-[174px] " />

            <div className="text-[#FF6600] font-bold text-2xl text-center !mb-1">
              {title}
            </div>

            <div className="text-[#19295C] text-center font-semibold text-sm ">
              {message}
            </div>
            <div className="flex  gap-4 my-2">
              {/* Google Play Button */}
              <img
                onClick={handelButton}
                src={android}
                alt="googlePlay"
                className="w-[130px] cursor-pointer"
              />

              {/* App Store Button */}
              <img
                onClick={handelButton}
                src={ios}
                alt="googlePlay"
                className="w-[130px] cursor-pointer "
              />
              {/* <a href={APKUrl}>
              </a>
              <a href={IOSUrl}>
              </a> */}
            </div>

            <div
              onClick={handelSecondButton}
              className=" cursor-pointer text-center w-full underline text-[#1A64B9] font-semibold text-[13px] leading-4 "
            >
              Continuer sur le web
            </div>

            {/* <div className="flex gap-4 items-center w-full !mt-4 mb-3 ">
              <button
                onClick={handelSecondButton}
                type="button"
                className="!rounded-md w-1/2  bg-white  !py-3 text-[#1A64B9] !border !border-[#1A64B9] font-medium text-sm "
              >
                {secondButtonTitle ?? "Annuler"}
              </button>
              <button
                onClick={handelButton}
                type="button"
                className="!rounded-md w-1/2   !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    "
              >
                {buttonTitle ?? "Confirmer"}
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RedirectMobileModal;
